<template>
  <div>
    <header1></header1>
    <div class="new_content" style="background: #fff;width:1002px;">
      <div class="new_findPwd_title" style="height: 76px;padding-left: 15px;">
        <router-link to="/findByMobile">手机找回密码</router-link>
        <!--<router-link to="/findByEmail" >邮箱找回密码</router-link>-->
        <router-link to="/findByWX" class="new_findPwd_title_sel">微信找回密码</router-link>
      </div>
      <div class="new_findPwd_main">
        <div class="new_fpwx_title" style="padding-left: 40px;color: #1d7a8e;">手机微信关注医博士公众号，点击下方“服务--找回密码”</div>
        <div class="fpwx_img" style="text-align: center"><img src="../assets/images/gyn/weixin_findpwd.jpg" width="714" height="325"/></div>
      </div>
    </div>
    <div style="width:1002px;margin: 0 auto;"><footer1></footer1></div>
  </div>
</template>
<style scoped>
  .new_findPwd_title {
    height: 37px;
    padding-top: 40px;
  }

  .new_findPwd_title a {
    display: block;
    float: left;
    width: 130px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    border: #c9c9c9 1px solid;
    border-bottom: 0px;
    margin-right: 12px;
    color: #5f5f5f;
  }

  .new_findPwd_title a.new_findPwd_title_sel{background:#1d7a8e; color:#fff;border:#1d7a8e 1px solid; border-bottom:0px;}

  .new_fpwx_title {
    color: #1d7a8e;
    font-weight: bold;
    text-align: left;
    line-height: 40px;
  }

  .new_fpwx_img {
    text-align: center;
  }

  .new_findPwd_main {
    width: 100%;
    min-height: 340px;
    border: 1px #c9c9c9 solid;
    padding: 40px 0px 0px 0px;
  }

  p.new_zc_sucess {
    width: 245px;
    padding-left: 36px;
    text-align: left;
    background: url(../assets/img-4/sucess_bg.gif) no-repeat left center;
    height: 40px;
    line-height: 40px;
    font-size: 30px;
    margin: 0px auto;
    color: #66a000;
  }

  p.new_zc_welcome {
    text-align: center;
    font-size: 14px;
    line-height: 40px;
  }

  p.new_zc_welcome span, p.new_zc_welcome a {
    color: #ff5300;
  }

  p.new_zc_welcome a:hover {
    text-decoration: underline
  }

</style>

<script>

  import header1 from '../components/Header1'
  import footer1 from '../components/Footer1'

  export default {
    components: {
      header1,
      footer1
    },
    data() {
      return {}
    }
  }

</script>



// WEBPACK FOOTER //
// src/views/FindByWX.vue